{
  "header": {
    "nameVariable": {
      "id": "01fa65cd-a012-44d6-9297-8d44691cf891",
      "modelUri": "http://opcfoundation.org/UA/MachineTool/",
      "nodeId": "ns=1;i=258",
      "displayName": "ProductInstanceUri",
      "variablePath": "Identification.ProductInstanceUri",
      "dataType": "String",
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "modelVariable": {
      "id": "d2ee0b95-f686-497a-8c20-28730a8c987a",
      "modelUri": "http://opcfoundation.org/UA/Machinery/",
      "nodeId": "ns=1;i=6008",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "modellingRule": "Optional",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "machine.jpg"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "valueVariable": {
                "id": "d6837b4b-bae5-4a5f-bd02-71ddd1141162",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=182",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "ProductUri",
              "showAsLink": true,
              "valueVariable": {
                "id": "d6b618a2-0ac5-4746-9778-4d9cead71d30",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=258",
                "displayName": "ProductInstanceUri",
                "variablePath": "Identification.ProductInstanceUri",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "valueVariable": {
                "id": "e40be8f5-7940-410f-ad25-c90e6aa9135a",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=259",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Software Version",
              "valueVariable": {
                "id": "c8145fac-8977-4eb8-bba1-9b0a25b15201",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6011",
                "displayName": "SoftwareRevision",
                "variablePath": "Identification.SoftwareRevision",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Build Year",
              "valueVariable": {
                "id": "f8f0fefe-d3f2-49bc-ae40-eeeabba8b08a",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6004",
                "displayName": "YearOfConstruction",
                "variablePath": "Identification.YearOfConstruction",
                "dataType": "UInt16",
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Device Class",
              "valueVariable": {
                "id": "ddc4aaca-9595-49c0-b3bc-e39c52f20131",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6012",
                "displayName": "DeviceClass",
                "variablePath": "Identification.DeviceClass",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Location",
              "valueVariable": {
                "id": "b5b7d4a8-097f-4c4f-8818-edb4a0a7e2de",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6029",
                "displayName": "Location",
                "variablePath": "Identification.Location",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "valueVariable": {
                "id": "2890fa7a-5aa6-4579-b834-92597590b573",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6008",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Code",
              "valueVariable": {
                "id": "416889bd-eec5-4470-9867-731c9e6141a9",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6009",
                "displayName": "ProductCode",
                "variablePath": "Identification.ProductCode",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    }
  ]
}
